<template>
  <div>
    <common-list
      ref="list"
      url="VehicleDisassemble/GetList"
      :init="filter"
      :isindex="false"
      @currentrow="handlerCurrentRow"
      @selected="selected"
    >
      <!-- 条件区域 -->
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="入场编号">
            <el-input
              v-model="filter.RegistrationNum"
              placeholder="入场编号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车牌号">
            <el-input
              v-model="filter.LicensePlate"
              placeholder="车牌号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车架号">
            <el-input
              v-model="filter.Vin"
              placeholder="车架号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="领车人">
            <RemoteSelect
              v-model="filter.DisassembleUserId"
              url="User/GetOrgUserList"
              code="UId"
              name="Username"
            ></RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="领车时间">
            <DateRangePicker
              v-model="filter.DisSearchDate"
              placeholder="选择日期"
              clearable
            ></DateRangePicker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="拆解人">
            <RemoteSelect
              v-model="filter.DisassembleFinshUserId"
              url="User/GetOrgUserList"
              code="UId"
              name="Username"
            ></RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="拆解时间">
            <DateRangePicker
              v-model="filter.FinearchDate"
              placeholder="选择日期"
              clearable
            ></DateRangePicker>
          </el-form-item>
        </el-col>
      </template>
      <!-- 按钮区域 -->
      <template v-slot:option>
        <el-button type="warning" icon="el-icon-edit" @click="show"
          >查看</el-button
        >
        <el-button type="primary" icon="el-icon-tickets" @click="Add"
          >完成拆解</el-button
        >
        <print
          @onClickPrint="onClickPrint"
          :options="printoptions"
          PrintName="bfcljxd"
        ></print>
      </template>
      <!-- 数据展示区域 -->
      <template v-slot:body>
        <el-table-column
          type="selection"
          :selectable="disablechcekbox"
          width="55"
          :selectedValue="selectedValue"
        >
        </el-table-column>
        <el-table-column
          label="车辆编号"
          prop="CarId"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="入场编号/喷漆编号"
          prop="RegistrationNum"
          width="200"
          show-overflow-tooltip
        >
          <template slot-scope="scope"
            >{{
              scope.row.RegistrationNum == 0
                ? "未编号"
                : scope.row.RegistrationNum
            }}
          </template></el-table-column
        >
        <el-table-column
          label="整车照片"
          prop="VehiclePhoto"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="{ row }">
            <el-image
              style="width: 30px; height: 30px"
              :src="row.VehiclePhotoUrl"
              :preview-src-list="[row.VehiclePhotoUrl]"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="车牌号"
          prop="LicensePlate"
          show-overflow-tooltip
          width="120"
        >
          <template slot-scope="scope">{{
            scope.row.LicensePlate | gang
          }}</template>
        </el-table-column>
        <el-table-column
          label="车架号"
          prop="Vin"
          show-overflow-tooltip
          width="200"
        >
          <template slot-scope="scope">{{ scope.row.Vin | gang }}</template>
        </el-table-column>
        <el-table-column
          label="净重"
          prop="CarWeith"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="{ row }"> {{ row.CarWeith | gang }}</template>
        </el-table-column>
        <el-table-column
          label="领出人"
          prop="DisassembleUser"
          show-overflow-tooltip
          width="120"
          ><template slot-scope="{ row }">
            {{ row.DisassembleUser | gang }}
          </template></el-table-column
        >
        <el-table-column
          label="领出时间"
          prop="DisassembleDate"
          show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.DisassembleDate | gang }}
          </template></el-table-column
        >
        <el-table-column
          label="拆解人"
          prop="DisassembleFinshUser"
          show-overflow-tooltip
          width="120"
          ><template slot-scope="{ row }">
            {{ row.DisassembleFinshUser | gang }}
          </template></el-table-column
        >
        <el-table-column
          label="拆解时间"
          prop="DisassembleFinshDate"
          show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.DisassembleFinshDate | gang }}
          </template></el-table-column
        >
        <!-- <el-tag
              v-if="row.QueueStatus == 3"
             size="medium" 
             :type="'danger'" 
             effect="light"
             >
              {{ row.QueueStatus | enumer('register_queue_state') }}
            </el-tag> -->
        <el-table-column label="状态" prop="QueueStatus" show-overflow-tooltip
          ><template slot-scope="{ row }">
            <el-tag
              size="medium"
              :type="row.QueueStatus == 5 ? '' : 'danger'"
              effect="plain"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
          </template></el-table-column
        >
      </template>
    </common-list>
    <!-- 弹窗区域 -->
    <div>
      <!-- <AddWeighDialog
        :item="itemAddWeighShow"
        @success="getData"
      ></AddWeighDialog>
      <ShowSettlementDialog
        :item="itemSettlementShow"
        @success="getData"
      ></ShowSettlementDialog> -->
    </div>
  </div>
</template>

<script>
// import "viewerjs/dist/viewer.css";
// import AddWeighDialog from "./Weigh";
// import ShowSettlementDialog from "./Settlement";
export default {
  components: {
    // AddWeighDialog,
    // ShowSettlementDialog,
  },
  computed: {},
  data() {
    return {
      Status: [],
      // itemAddWeighShow: {},
      // itemSettlementShow: {},
      filter: {
        StatusArray: [],
      },
      radio: 1,
      srcList: [],
      selectedValue: [],
      printoptions: {}, //打印参数
      defaultImageUrl:
        "https://chaijieapi.zemichykj.com/images/my/light/CarDefault.png",
    };
  },
  watch: {},
  methods: {
    //重新加载数据
    getData() {
      this.$refs.list.getTableData();
    },
    //显示图片
    showImg(path) {
      this.srcList.push(path);
    },

    Add() {
      let carid = [];
      this.selectedValue.forEach((p) => {
        carid.push(p.CarId);
      });
      if (carid.length == 0) {
        this.$message.error("请选择要拆解的车辆");
        return;
      }
      this.$confirm(`将完成拆解选中的车辆, 是否继续?`, "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "el-button--canale",
        type: "warning",
      })
        .then(() => {
          this.$post("VehicleDisassemble/GetVehicles", {
            KeyId: carid,
          }).then(() => {
            this.$message.success("领取成功");
            this.getData();
          });
        })
        .catch(() => {});
    },
    show() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$router.push({
        name: "VehicleRegistShow/:KeyId/:IsEdit",
        params: {
          KeyId: this.currentrow.CarId,
          IsEdit: true,
        },
      });
    },
    disablechcekbox(row, index) {
      var boo = true;
      if (row.QueueStatus == 6) {
        boo = false;
      }
      return boo;
    },
    ShowMissingParts() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemMissingPartsShow = {
        KeyId: this.currentrow.KeyId,
      };
    },
    ShowAddWeighParts() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemAddWeighShow = {
        KeyId: this.currentrow.CarId,
      };
    },
    selected(val) {
      this.selectedValue = val;
    },
    onClickPrint(type, callback) {
      if (!this.hasCurrentRow()) {
        return;
      }
      if (this.currentrow.QueueStatus != "6") {
        this.$message.error("请先完成拆解再打印");
        return;
      }
      var id = this.currentrow.CarId;
      if (id == null || id.length == 0) {
        this.$message.error("未获取选中的列表");
        return;
      }
      this.printoptions = { id: id };
      callback(this.printoptions); //callback 执行打印 false不执行
    },
  },
};
</script>

<style></style>
